import axiosInstance from '../axiosInstance';
import Auth from '../modules/auth';

export const getNow = async () => {
  try {
    const valueNow = await axiosInstance.get('/now');
    
    return valueNow.data;
  } catch (error) {
    //console.log(error);
    return {error:"Serverul INFOWORLD de furnizare a informatiilor privind disponibilitatea paturilor nu raspunde cererilor sau este indisponibil!"}
  }
};
export const getHospitalByDRG = async (hospitalCode) => {
  try {
    var token = await Auth.getToken();
    const valueNow = await axiosInstance.get('/nomenclatures/hospitals/?codeDRG=' + hospitalCode,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return valueNow.data;
  } catch (error) {
    console.error(error);
  }
};
export const getSectionByDRG = async (sectionCode) => {
  try {
    var token = await Auth.getToken();
    const valueNow = await axiosInstance.get('/nomenclatures/sections/?codeDRG=' + sectionCode,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return valueNow;
  } catch (error) {
    console.error(error);
  }
};

export const getLastDate = async () => {
  try {
    var token = await Auth.getToken();
    const valueNow = await axiosInstance.get('/lastDay',{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return valueNow.data;
  } catch (error) {
    console.error(error);
  }
};

export const getLastWeek = async () => {
  try {
    var token = await Auth.getToken();
    const valueNow = await axiosInstance.get('/lastWeek',{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return valueNow.data;
  } catch (error) {
    console.error(error);
  }
};


export const getLastMonth = async () => {
  try {
    var token = await Auth.getToken();
    const valueNow = await axiosInstance.get('/lastMonth',{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return valueNow.data;
  } catch (error) {
    console.error(error);
  }
};

export const getTimeFrame = async (lowerLimit, higherLimit) => {
  try {
    var token = await Auth.getToken();
    const valueNow = await axiosInstance.get('/timeframe?lowerLimit=' + lowerLimit + '&higherLimit=' + higherLimit,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return valueNow.data;
  } catch (error) {
    console.error(error);
  }
};
